import ReimbursementSummaryLeadAccount from './reimbursement-summary-lead-account';
import t from 'tcomb';

const ReimbursementSummary = t.list(ReimbursementSummaryLeadAccount, 'ReimbursementSummary');

export const getDefaultState = () => new ReimbursementSummary([]);

export default ReimbursementSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/reimbursement-summary.js